<!--  -->
<template>
  <div>
    <van-popup
      v-model="show"
      position="bottom"
      :style="{ height: '52%' }"
      duration="0.18"
      :close-on-click-overlay="false"
    >
      <div class="title">
        <p>请选择课程</p>
        <van-icon name="cross" @click="onClose" />
      </div>
      <div class="content">
        <div class="courseSelect" v-for="(item, n) in productSpecJson" :key="n">
          <h3 class="subheading">{{ item.name }}</h3>
          <div class="courseSelectTabs">
            <p
              v-for="(list, index) in item.options"
              @click="chooseSkuInfo(list.name, n, $event, index, list.isShow)"
              :class="{
                tabItem: true,
                tabSelected: subIndex[n] == index,
                noneActive: !list.isShow,
                hidden: list.isHidden,
              }"
              :key="index"
            >
              <span>{{ list.name }}</span>
              <img v-if="subIndex[n] == index" :src="checkIcon" alt="checkIcon" />
            </p>
          </div>
        </div>
      </div>
      <div class="foot">
        <div @click="toBuy">确认</div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import checkIcon from '@/assets/img/components/courseDetail/checkIcon.png';

export default {
  components: {},
  data() {
    return {
      checkIcon,
      show: false,
      selectedIndex: 0,
      productSpecJson: [], // 展示在页面的sku规格
      iconChecked: checkIcon, // sku选中状态icon
      selectArr: [], // 选中的值
      shopItemInfo: {}, // 存放要和选中的值进行匹配的数据
      subIndex: [], // 是否选中
      selectSku: {}, // 选中的sku信息
      someOne: null, // 可用的一条sku，用于展示默认的sku
    };
  },
  props: {
    courseInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {},
  mounted() {
    this.modifySkuRespVOList();
  },
  methods: {
    onClose() {
      this.show = false;
      // this.$emit('close', false);
    },
    toBuy() {
      console.log(this.selectSku, 'selectSku');
      const { productId } = this.courseInfo;
      const { productSkuId } = this.selectSku;
      this.$emit('sendSku', { productId, productSkuId });
    },
    // 选中sku属性
    chooseSkuInfo(item, n, event, index, canClick) {
      if (!canClick) {
        return false;
      }
      if (this.selectArr[n] !== item) {
        [this.selectArr[n], this.subIndex[n]] = [item, index];
      } else {
        this.selectSku = {};
        [this.selectArr[n], this.subIndex[n]] = ['', '-1'];
      }
      this.checkItem();
      return true;
    },
    checkItem() {
      const self = this;
      const result = this.selectArr; // 定义数组储存被选中的值
      for (let i = 0; i < this.productSpecJson?.length; i += 1) {
        result[i] = self.selectArr[i] ? self.selectArr[i] : '';
      }
      if (this.productSpecJson) {
        this.productSpecJson.forEach((element, i) => {
          const last = result[i];
          element.options.forEach((k) => {
            result[i] = k.name;
            Object.assign(k, { isShow: self.someOne ? self.isMay(result) : false }); // isShow来判断是否可以选择})
          });
          result[i] = last; // 还原，目的是记录点下去那个值
        });
      }
      if (this.shopItemInfo[result]) {
        this.selectSku = this.shopItemInfo[result];
      }
      self.$forceUpdate(); // 重绘
    },
    // 能否被选中
    isMay(result) {
      for (let k = 0; k < result.length; k += 1) {
        if (result[k] === '') {
          return true;
        }
      }
      // 校验list中是否有此条sku
      if (result && !this.shopItemInfo[result]) {
        return false;
      }
      // 库存校验
      return !(
        this.shopItemInfo[result].isSetStock === 1 && this.shopItemInfo[result].availableStock === 0
      );
    },
    // 修改数据结构,将选中的值作为key，以方便和选中之后的值进行匹配
    modifySkuRespVOList() {
      const { productSkuRespVOList, productSpecJson } = this.courseInfo;
      if (!productSpecJson && !productSkuRespVOList?.length) return;
      if (!productSpecJson) {
        // 无sku
        this.$store.dispatch('saveProductSku', productSkuRespVOList[0]);
        return;
      }
      productSkuRespVOList.forEach((item) => {
        this.shopItemInfo[String(JSON.parse(item.specJson).map((child) => child.value))] = item;
      });

      JSON.parse(productSpecJson).forEach((item) => {
        Object.assign(item, {
          options: item.options.map((element) => ({
            name: element,
          })),
        });
        this.productSpecJson.push(item);
      });
      this.setDefault(productSkuRespVOList);
      this.checkItem();
    },
    // 默认一个可用的sku
    setDefault(productSkuRespVOList) {
      const defautIdx = [];
      const defautName = [];
      this.someOne = productSkuRespVOList.find(
        (item) => (item.isSetStock === 1 && item.availableStock > 0) || item.isSetStock === 0,
      );
      console.log(this.someOne, productSkuRespVOList, 'this.someOne');
      if (!this.someOne) return;
      this.productSpecJson.forEach((item) => {
        item.options.forEach((list, i) => {
          JSON.parse(this.someOne.specJson).forEach((m) => {
            if (list.name === m.value) {
              defautName.push(list.name);
              defautIdx.push(i);
            }
          });
        });
      });
      this.subIndex = defautIdx;
      this.selectArr = defautName;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-popup {
  overflow-y: hidden;
  border-radius: 27px 27px 0 0;
}
.title {
  position: relative;
  width: 100%;
  height: 118px;
  padding: 36px 0 0 0;
  background: #f7f8fc;
  > p {
    color: #333;
    font-weight: 500;
    font-size: 33px;
    text-align: center;
  }
}
::v-deep .van-icon {
  position: absolute;
  top: 18px;
  right: 18px;
  font-size: 20px;
}
.content {
  height: 1050px;
  padding-bottom: 120px;
  overflow: hidden;
}

.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 167px;
  background: #fff;
  box-shadow: 0 -4 14px 0 rgba(0, 0, 0, 0.05);
  div {
    width: 678px;
    height: 80px;
    margin: 22px auto 0;
    color: #fff;
    font-weight: 500;
    font-size: 29px;
    line-height: 80px;
    text-align: center;
    background: #ff7f41;
    border-radius: 49px;
  }
}
.courseSelect {
  display: flex;
  width: 100%;
  min-height: 130px;
  // margin: 22px 0;
  padding: 16px 36px 0;
  background: #fff;
  // border-radius: 14px;
  // box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.03);

  &:first-child {
    padding-top: 26px;
  }
  &:last-child {
    padding-bottom: 26px;
  }

  .subheading {
    flex-shrink: 0;
    min-width: 60px;
    margin-right: 19px;
    padding-top: 26px;
    color: #333;
    font-weight: bold;
    font-size: 25px;
    line-height: 30px;
  }
  .courseSelectTabs {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    margin-left: 4px;

    p {
      position: relative;
      box-sizing: border-box;
      min-width: 173px;
      margin: 10px;
      padding: 12px 12px 12px 12px;
      color: #787878;
      font-size: 22px;
      line-height: 30px;
      text-align: center;
      background: #fff;
      border: 1.1px solid #e8e8e8;
      border-radius: 4px;

      img {
        position: absolute;
        right: 0;
        bottom: 0;
        display: none;
        width: 30px;
        height: auto;
      }
    }

    /* p:nth-child(3n) {
      margin-right: 0;
    }

    p:nth-child(n + 4) {
      margin-top: 20px;
    } */

    .tabSelected {
      box-sizing: border-box;
      color: #ff6c02;
      background: #fff5ed;
      border: 2px solid #ff6c02;
      border-radius: 4px;
      pointer-events: none;
      img {
        display: block;
      }
    }
    .hidden {
      display: none;
    }
    .noneActive {
      color: #cfcfcf;
      background: #f5f5f5;
      border: 2px solid #f5f5f5;
      border-radius: 4px;

      img {
        display: none;
      }
    }
  }
}
</style>
